module.exports = __webpack_public_path__ + "static/media/close-white.b502105b.svg";